


















import Vue from 'vue'
import { mapGetters } from 'vuex'
import TenantCreateButton from '@/components/TenantCreateButton.vue'
import TenantMemberships from '@/components/TenantMemberships.vue'
import { signoutConfirm } from '@/utility/helpers'
export default Vue.extend({
    components: { TenantCreateButton, TenantMemberships },
    data() {
        return {
            back: false,
            toolbar: {
                title: 'Workspaces',
                left: [],
                right: []
            }
        }
    },
    computed: {
        ...mapGetters(['tenantMemberships', 'user']),
        displayBack(): boolean {
            return this.$vuetify.breakpoint.xsOnly && this.back
        },
        multitenantEnabled(): boolean {
            //  Check if this user is a reseller, and if so, return true
            if (this.user.reseller) return true

            //  If there are somehow no memberships, false
            if (!this.tenantMemberships) return false

            //  If this user has ANY subscriptions that has an empower plan, enable this
            for (let i = 0; i < this.tenantMemberships.length; i++) {
                //  Grab the membership's tenant
                let tenant = this.tenantMemberships[i]

                //  Check this tenant's tier, and if it is advanced, proceed
                if (tenant.subscription_tier == 'advanced') return true
            }

            return false
        }
    },
    methods: {
        signoutConfirm(): void {
            signoutConfirm()
        }
    }
})
